interface PoliceOverviewLoadingStateProps {
  message?: string;
}

export const PoliceOverviewLoadingState = ({
  message = 'Loading police reports...',
}: PoliceOverviewLoadingStateProps) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto" />
        <p className="mt-2 text-gray-600">{message}</p>
      </div>
    </div>
  );
};
